<template>
  <v-content class="login fill-height background">
    <v-container fill-height
                 class="flex-column">
      <v-row fill-height
             no-gutters
             align="center"
             justify="center">
        <v-col class="pa-5 align-center d-md-flex"
               cols="12"
               lg="6"
               order="3"
               order-sm="1">
          <v-card class="py-8 px-4">
            <v-form ref="signInForm"
                    v-model="form"
                    lazy-validation
                    class="px-5">
              <v-row no-gutters>
                <h2 class="headline font-weight-regular primary--text pb-5">
                  Entrar no acervo
                </h2>
                <v-col cols="12">
                  <v-text-field v-model="email"
                                :rules="[rules.emailRules, rules.required]"
                                label="E-mail"
                                type="email"
                                placeholder="Entre com o seu e-mail"
                                required
                                @keyup.enter.native="onSubmit" />
                </v-col>
                <v-col cols="12">
                  <v-text-field v-model="password"
                                :rules="[rules.min8, rules.required]"
                                label="Senha"
                                :append-icon="showPass ? 'fas fa-eye' : 'fas fa-eye-slash'"
                                :type="showPass ? 'text' : 'password'"
                                placeholder="Entre com a sua senha de 8 ou mais caracteres"
                                required
                                @click:append="showPass = !showPass"
                                @keyup.enter.native="onSubmit" />
                </v-col>
              </v-row>
              <div class="pt-5 pb-5 text-right">
                <router-link :to="{ name: 'ForgotPassword' }"
                             class="accent--text mr-4"
                             style="text-decoration: none">
                  Esqueci minha senha
                </router-link>
                <v-btn rounded
                       color="primary"
                       :block="$vuetify.breakpoint.smAndDown"
                       @click="onSubmit">
                  Entrar
                </v-btn>
              </div>
              <div class="pt-5 text-right">
                Ainda não possui conta?
                <v-btn text
                       :block="$vuetify.breakpoint.smAndDown"
                       @click="onRegister">
                  Clique aqui para criar uma.
                </v-btn>
              </div>
            </v-form>
          </v-card>
        </v-col>
        <v-col class="align-center text-center white--text"
               cols="12"
               lg="6"
               order="2">
          <h1 class="headline font-weight-regular pb-5">
            Bem-vindo ao Centro <br>de Memória
          </h1>
          <p style="max-width: 400px"
             class="mx-auto">
            A Wilson Sons acredita que os registros da sua trajetória
            são parte integrante do seu legado para a sociedade. Por
            isso, em 2006, implantou o Centro de Memória, que disponibiliza
            o seu acervo on-line para consultas e atende pesquisadores
            do Brasil e do Exterior.
          </p>
          <router-link :to="{name: 'Dashboard'}">
            <img src="@/assets/logo-small.png">
          </router-link>
        </v-col>
      </v-row>
    </v-container>
  </v-content>
</template>

<script>
/* eslint-disable global-require */
import { mapActions } from 'vuex';
import formRules from '@/mixins/form-rules';

export default {
  name: 'Login',
  props: {
    sessionError: {
      type: Error,
      default: null,
    },
  },
  mixins: [formRules],
  data() {
    return {
      email: null,
      password: null,
      showPass: false,
      error: null,
      form: true,
      slides: [
        {
          src: require('@/assets/10-anos.jpg'),
          title: 'Bem vindo ao Centro de Memória',
          description:
            'A Wilson Sons acredita que sua trajetória deve ser compartilhada por todos que fazem parte dessa história. Por isso, depois de implantar o Centro de Memória e o Portal da Memória, foi disponibilizado total acesso ao acervo da companhia.',
        },
      ],
    };
  },
  watch: {
    sessionError: {
      handler(err) {
        this.error = err;
      },
      immediate: true,
    },
  },
  methods: {
    ...mapActions('auth', ['signIn']),
    onSubmit(evt) {
      evt.preventDefault();
      this.error = null;
      if (this.$refs.signInForm.validate()) {
        this.signIn({
          email: this.email.trim().toLowerCase(),
          password: this.password,
        })
          .then((acc) => {
            if (acc.status) {
              this.$router.push({ name: 'Acervo listar' });
            } else {
              this.$toasted.error('O seu usuário está bloqueado. '
              + 'Se você acredita que isso é um erro, entre em contato com o administrador do sistema.');
            }
          })
          .catch(() => {
            this.$toasted.error('E-mail ou senha incorretos');
          });
      }
    },
    onRegister() {
      this.$router.push({ name: 'Acervo listar' });
      this.$store.dispatch('views/collection/list/onRegisterDialogInput', true, { root: true });
    },
  },
};
</script>
